"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.describe = describe;
var _debrief = require("debrief");

/**
 * Wrap another decoder, and override the error message in case it fails. This
 * is useful to "simplify" otherwise potentially complex error messages, or to
 * use language in those error messages that can be relayed to end users (for
 * example to show in form errors).
 */
function describe(decoder, message) {
  return function (blob) {
    return decoder(blob).mapError(function (err) {
      return (0, _debrief.annotate)(err, message);
    });
  };
}